import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const LANG_TO_LOCALE: Record<string, string> = {
	cs: "cs-CZ",
	en: "en-GB",
};

export const useNumberFormatter = () => {
	const { i18n } = useTranslation();
	const locale = LANG_TO_LOCALE[i18n.language] ?? "cs-CZ";

	return useCallback(
		(
			value: number | null | undefined,
			options?: Intl.NumberFormatOptions,
		): string | null => {
			if (value === null || value === undefined) return null;
			return new Intl.NumberFormat(locale, options).format(value);
		},
		[locale],
	);
};
